import Views from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';

const getRelayEntries = (viewName, route) => {
  const isCurrent = (viewName === Views.OME_MEET_RELAY_ENTRIES) === true ? true : false;

  const arePrerequisitesDone = true;

  const isComplete = true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_RELAY_ENTRIES) : getInitialStateMeetRoute(Views.OME_MEET_RELAY_ENTRIES);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getRelayEntries;